// Affiche le prix réellement payé par un vendeur Pro (-30%) ou un VDI en achat-revente actif
// (-30%/-35% selon son palier) sur TOUTE page de la boutique — la remise elle-même est déjà
// appliquée automatiquement au paiement par les Shopify Functions existantes
// (extensions/pro-discount, extensions/vdi-personal-discount) ; ce script ne fait qu'informer le
// visiteur en amont, il ne change rien au calcul réel de la commande. Pas de dégressivité par
// quantité pour ces deux profils : uniquement le pourcentage plat, jamais cumulé aux paliers
// affichés par ailleurs sur les fiches produit.
//
// Deux façons d'utiliser ce script :
//  1. Prix statiques (collections, carrousels, quickview...) : voir snippets/price.liquid, qui pose
//     data-price-cents sur l'élément — traité automatiquement par applyAll() ci-dessous.
//  2. Prix qui changent en JS selon l'option choisie (fiches produit personnalisées — sucre,
//     sans-sucre, coffret, écrin, kits, préparation, rituel) : chaque template appelle
//     window.SellerPricing.apply(element, prixEnCentimes) lui-même, à chaque fois qu'il met à jour
//     son propre affichage de prix. Contrairement à data-price-cents (traité une seule fois),
//     apply() retraite l'élément à chaque appel — nécessaire puisque le prix y change réellement.
(function () {
  var percent = 0;
  var label = '';
  var ready = false;
  var pending = []; // [element, cents] appelés par une fiche produit avant que le % soit connu
  var readyCallbacks = []; // callbacks onReady() enregistrés avant que le % soit connu

  function formatMoney(cents) {
    try {
      if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
    } catch (e) {}
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  // Remplace le contenu de l'élément par : prix plein tarif barré + prix remisé + badge. Toujours
  // rejoué en entier (pas de garde "déjà appliqué") car cette fonction sert aussi aux prix qui
  // changent dynamiquement sur les fiches produit.
  function render(el, cents) {
    if (!percent || !el || !cents || isNaN(cents)) return;
    var discountedCents = Math.round(cents * (1 - percent / 100));

    var original = document.createElement('s');
    original.className = 'seller-price-original';
    original.textContent = formatMoney(cents);

    var discounted = document.createElement('span');
    discounted.className = 'seller-price-discounted';
    discounted.textContent = formatMoney(discountedCents);

    var badge = document.createElement('span');
    badge.className = 'seller-price-badge';
    badge.textContent = label + ' −' + percent + '%';

    el.textContent = '';
    el.appendChild(original);
    el.appendChild(discounted);
    el.appendChild(badge);
    el.dataset.sellerPriceApplied = '1';
  }

  // API publique — appelée directement par les fiches produit personnalisées à chaque mise à jour
  // de leur prix (changement de format, quantité, abonnement...). Sûre à appeler même avant que le
  // statut du visiteur soit connu : mise en attente, puis rejouée automatiquement.
  window.SellerPricing = {
    apply: function (el, cents) {
      if (!el) return;
      if (!ready) {
        pending.push([el, cents]);
        return;
      }
      render(el, cents);
    },
    // Calcul pur, sans toucher au DOM — pour les affichages qui ne peuvent pas passer par apply()
    // tel quel (ex: paliers de quantité "combien de pots ?", qui n'ont pas leur propre remise
    // dégressivité pour un vendeur Pro/VDI : juste ce % plat multiplié par la quantité, pas de badge
    // "ancien prix" à poser dessus). Retourne cents inchangé si aucune remise (donc toujours sûr à
    // utiliser, même avant que le % soit connu — mais voir onReady() pour être notifié du bon moment).
    discount: function (cents) {
      return percent ? Math.round(cents * (1 - percent / 100)) : cents;
    },
    percent: function () { return percent; },
    label: function () { return label; },
    // Appelle callback() une fois le statut du visiteur connu (immédiatement si déjà connu) — pour
    // les fiches produit qui doivent recalculer autre chose que de simples prix (ex: masquer les
    // badges de remise dégressive "-2%"/"-5%" sur les paliers de quantité).
    onReady: function (callback) {
      if (ready) { callback(); return; }
      readyCallbacks.push(callback);
    }
  };

  function applyStatic(el) {
    if (el.dataset.sellerPriceApplied === '1') return;
    // Produits partenaires (kits échantillons, flyers personnalisés) : prix déjà final, aucune
    // remise VDI/Pro ne doit s'y afficher — marqués data-no-seller-discount par snippets/price.liquid
    // (produit taggé "vdi-exclusif"). La Function de remise les exclut aussi côté checkout.
    if (el.hasAttribute('data-no-seller-discount') || el.closest('[data-no-seller-discount]')) return;
    var cents = parseInt(el.getAttribute('data-price-cents'), 10);
    render(el, cents);
  }

  function applyAllStatic() {
    document.querySelectorAll('[data-price-cents]').forEach(applyStatic);
  }

  // Couvre les prix statiques ajoutés après le chargement initial (quickview en modale, carrousels
  // de recommandations chargés en AJAX, filtres de collection) — applyStatic() ignore déjà tout
  // élément marqué sellerPriceApplied, donc réappliquer sur toute mutation reste bon marché. Les
  // fiches produit personnalisées, elles, sont couvertes par leurs propres appels à
  // window.SellerPricing.apply() à chaque changement d'option, pas par cet observer.
  function watchForNewStaticPrices() {
    var observer = new MutationObserver(applyAllStatic);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  fetch('/apps/loyalty/seller-discount')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      percent = Number(data.percent) || 0;
      label = data.label || 'Votre prix';
      ready = true;
      if (percent > 0) {
        applyAllStatic();
        watchForNewStaticPrices();
        pending.forEach(function (entry) { render(entry[0], entry[1]); });
      }
      pending = [];
      readyCallbacks.forEach(function (cb) { cb(); });
      readyCallbacks = [];
    })
    .catch(function () {
      ready = true;
      pending = [];
      readyCallbacks.forEach(function (cb) { cb(); });
      readyCallbacks = [];
    });
})();
